module.exports = __webpack_public_path__ + "img/3.fdbe9194.jpg";